import { Controller } from "@hotwired/stimulus";

// Controls the navigation links and burger/close buttons in the header
export default class extends Controller {
  static targets = ["nav"];

  declare readonly navTarget: HTMLElement;


  toggle() {
    if (this.navTarget.classList.contains("open")) {
      this.showNav();
    } else {
      this.hideNav();
    }
  }

  showNav() {
    this.navTarget.classList.remove("open");
    this.element.classList.remove("header--open");
    setTimeout(() => {
      this.navTarget.classList.remove("visible");
    }, 400);
  }

  hideNav() {
    this.navTarget.classList.add("visible");
    setTimeout(() => {
      this.navTarget.classList.add("open");
      this.element.classList.add("header--open");
    }, 20);
  }
}
